import React, { useState,useEffect } from "react";
import './styles/board.css';
import Cell from "./cell";

function Board({guess,puzzle,puzzleID}){

	/**
	 * This code snippet is responsible for
	 * creating a list of cells
	 */
	 const listOfCells = [];
	 useEffect(()=>{
		for (var i = 1 ; i < 53; i++){
			listOfCells[i-1]= {id: i, value: '', style: ''}
		}
	 })



	/**
	 * This piece of data is shared with 
	 * the cell class as a style to update 
	 * its rotation value 
	 * when guess is good
	 */
	const rotateShow = "revealValue";


	/**
	 * This piece of data is shared with 
	 * the cell class as a style to update 
	 * its color to white 
	 * when setting the puzzle 
	 */
	const lightCell = "lightUp"

	/**
	 * This code snippet creates a copy of 
	 * the list to mmodify and pass it later
	 * to the cells to display the data
	 */
	const [cellList,setCellsList] = useState(listOfCells);
	

	/**
	 * This code snippet runs everytime 
	 * we get a new puzzle and its effect updates
	 * the whole board
	 */
	useEffect(()=>{
		setPuzzle(puzzle)
	},[puzzle,puzzleID])

	/**
	 * this code runs eveytime user enteres
	 * a new guess here we set the guess 
	 * passed to a local variable state
	 */
	const [playerGuess,setplayerGuess]=useState();
	useEffect(()=>{

		if(typeof guess !== 'undefined'){
			setplayerGuess(guess)
		}	
	},[guess])

	/**
	 * here everytime the local variable that 
	 * holds the guess value changes this method 
	 * gets invooked this method is responsible 
	 * for updating the values of the temporary list
	 * then updates the number of matching guesses 
	 * in the puzzle so it can be then used by 
	 * the controller to multiply rewards 
	 */
	useEffect(()=>{

		var tempguess;
		var tempPass = false;

		// check if guess is not undefined
		if(playerGuess){
			// in the case of solve puzzle
			tempguess = playerGuess.toUpperCase()

			if(tempguess.length === puzzle.length){
				// upper case to compare it
				if(tempguess === puzzle){
					// this means we should validate a whole sentence
					tempPass = true;
				}
			}
		}

		// this is a map function
		const updatedCellsList = cellList.map(cell => {
			// if we are premitted to validate whole sentence
			if(tempPass){
				/* This section disaply all the cells that have value hidden */
				if(cell.value.length === 1){
					return {...cell, style: rotateShow}
				}		
			// if not a whole sentence then we only show the ones that hold the value		
			} else if(cell.value === tempguess){					
				return {...cell, style: rotateShow}
			}	
			return cell;
		});
		
		// here we update our list
		setCellsList(updatedCellsList);
	},[playerGuess])

	/**
	 * This method is responsible for injecting #
	 * in a list and return it
	 * @param {list contains one word of the puzzle } list 
	 * @param {list of the puzzle words} words 
	 * @returns 
	 */
	const organize = (list,words)=>{
		var temp = list;		
		var wordCounter = temp[0].length+1;
		var curRowLimit = 13;

		/**
		 * here we loop until the end of words
		 */
		for(var i = 1; i < words.length; i++){

			var curWord = words[i];			
			var curWordLength = curWord.length+1;
			
			/**
			 * if words length and the cureent word length DO NOT 
			 * exceed the current row length
			 */
			if((wordCounter + curWordLength) < curRowLimit){
				/**
				 * add the word then update count
				 */
				temp.push(curWord);
				wordCounter += curWordLength;

			}else{
				/**
				 * if it exceeds add # then
				 * add the word then update count
				 */
				temp.push('#');
				temp.push(curWord);
				wordCounter = curRowLimit + curWordLength;
				
				/**
				 * updates the row limit
				 */
				if(curRowLimit === 53){
					curRowLimit += 12 
				} else if(curRowLimit === 41){
					curRowLimit += 12 
				} else if(curRowLimit === 27){
					curRowLimit += 14 
				}else if(curRowLimit === 13){
					curRowLimit += 14 
				}
			}
		}
		return temp;
	}

	/**
	 * This method is responsible for diaplying the cells
	 * @param {start location of cells holding the puzzle} startLocation 
	 * @param {a sentence representing the puzzle list after the injections } puzzleLetters 
	 * @param {determine whether show or hide the puzzle} whichStyle 
	 */
	const visualize = (startLocation,puzzleLetters,whichStyle)=>{
		const newUpdate = cellList.map(cell => {
			var locator = 0;
			var iValue  = startLocation;
			
			for (var i = iValue ; i < 52; i ++){
				
				var tempLetter = puzzleLetters.charAt(locator)
				
				
				/**
				 * when we read a # we need
				 * to know where the cursor is at
				 * then we update it to the following row
				 */
				if(tempLetter === "#"){
					
					if(i <= 12){
						i = 13
					}else if(i <= 26 && i > 13){
						i = 27
					}else if(i <= 40 && i > 27){
						i = 40
					}
					
				} 
				/**
				 * then we set the cell value and style if
				 * the letter which i is at is not a # or a empty space
				 */
				if(cell.id === i){
					
					if(tempLetter !== "#"){
						if(tempLetter.trim() !== ''){
							return {...cell, value: puzzleLetters?.charAt(locator), style: whichStyle}
						}
					}
					
					

				}
				locator++;
			}
			return cell;
		});
		setCellsList(newUpdate);


	}

	/**
	 * This helper methos reads the needed slots and updates the start location
	 * @param {number of all the letters needed as including the spaces} neededSlots 
	 * @param {location were we start placing the cells} startLocation 
	 * @returns 
	 */
	const setLocation = (neededSlots,startLocation)=>{
		if(neededSlots > 40){
			startLocation = 13
		} else if(neededSlots > 26){
			startLocation = 1;
		} else {
			startLocation = Math.floor((52 - neededSlots)/2);
		} 

		if( startLocation > 8 && startLocation < 12){
			startLocation = 14;
		} else if( startLocation > 22 && startLocation < 26){
			startLocation = 28;
		}

		return startLocation;
	}

	
	/**
	 * this methos sets the puzzle and calls 
	 * the neccessary helper methods
	 * @param {is the current puzzle} newPuzzle 
	 */
	const setPuzzle = (newPuzzle) =>{

		/**
		 * we need an array of the words, as well as needed slots
		 * which are the letters of the puzzle including the spaces
		 * then we must know where to starting placing the cells then
		 *  the injected puzzle and the temporary array
		 */
		var words =[];
		var neededSlots;
		var startLocation;
		var puzzleLetters = "";
		var temp =[];
		

		if(newPuzzle){
			neededSlots = newPuzzle.length;
			words = newPuzzle.split(" ");
			temp.push(words[0])
			temp = organize(temp,words)
			console.log(temp)

		}

	
		startLocation =	setLocation(neededSlots,startLocation);


		for(var z = 0; z < temp.length; z++){
			if(temp[z] !== "#"){
				puzzleLetters += temp[z]+" ";
			} else if(temp[z] === "#"){
				puzzleLetters += temp[z];
			}
		}
		


		if(neededSlots > 40){
			puzzleLetters = "THE SENTENCE #CANNOT FIT #THE BOARD"
			visualize(startLocation,puzzleLetters,rotateShow);

		} else if(neededSlots > 0 && neededSlots < 53){
			visualize(startLocation,puzzleLetters,lightCell);
		}
		
	}


	const topRow = cellList.map((item) => {
		if(item.id <= 12){
			
			return <Cell value={item.value} style={item.style} />;
		}
	});

	const midRow = cellList.map((item) => {
		if(item.id > 12 && item.id <= 40){
			console.log(item.id)
			return <Cell value={item.value} style={item.style} />;
		}
	});

	const bottomRow = cellList.map((item) => {
		if(item.id > 40 && item.id <= 52){
			return <Cell value={item.value} style={item.style} />;
		}
	});

		
	return (
		<footer className='boardContainer' >
			{/* <div style={{backgroundColor: 'white', width: 'fit-content'}}>
				{puzzle}
			</div> */}


			<div className='upperLowerRows'>

				{topRow}

			</div>

			<div className='middleRows'>  

				{midRow}
				
			</div>

			<div className='upperLowerRows'>

				{bottomRow}
				
			</div>

		</footer>

	);	
}
export default Board